import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/compliance/components/ComplianceSkeleton.tsx");
